export default {
  'pages.layouts.userLayout.title':'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.serviceOverview.p1': 'Ecovacs core API now fully supports the MCP protocol, making it the world\'s first robot service provider compatible with the MCP protocol.',
  'pages.serviceOverview.p2': 'Ecovacs has completed the integration of 4 core API interfaces with the MCP protocol, including device list query, cleaning control, recharging control, and working status query.',
  'pages.serviceOverview.p3': 'As the world\'s first cleaning robot service provider to support the MCP protocol, after the release of Ecovacs MCP Server, AI agent developers only need simple configuration to quickly access robot services in large language models, enabling query, cleaning, recharging, and other capabilities.',
  'pages.serviceOverview.p4': 'This significantly lowers the threshold for calling robot control services during AI agent application development and greatly improves the development efficiency of AI agent applications.',
  'pages.serviceOverview.featureIntroduction': 'Feature Introduction',
  'pages.serviceOverview.deviceListQuery': 'Device List Query',
  'pages.serviceOverview.deviceListQuery.p1': 'Get a list of all robots bound to the user.',
  'pages.noParameters': 'No parameters',
  'pages.serviceOverview.statusDescription': 'status is 0 for success, -1 for failure',
  'pages.serviceOverview.cleaningControl': 'Cleaning Control',
  'pages.serviceOverview.cleaningControl.p1': 'Control the robot vacuum to start, pause, resume, or stop cleaning.',
  'pages.serviceOverview.cleaningControl.p2': 'Robot nickname, used to find the device, supports fuzzy matching',
  'pages.serviceOverview.cleaningControl.p3': 'Cleaning behavior',
  'pages.serviceOverview.cleaningControl.p4': 'Start cleaning',
  'pages.serviceOverview.cleaningControl.p5': 'Resume cleaning',
  'pages.serviceOverview.cleaningControl.p6': 'Pause cleaning',
  'pages.serviceOverview.cleaningControl.p7': 'Stop cleaning',
  'pages.serviceOverview.rechargeControl': 'Control Recharging',
  'pages.serviceOverview.rechargeControl.p1': 'Control the robot to start or stop recharging.',
  'pages.serviceOverview.rechargeControl.p2': 'Robot nickname, used to find the device',
  'pages.serviceOverview.rechargeControl.p3': 'Robot action',
  'pages.serviceOverview.rechargeControl.p4': 'Start recharging',
  'pages.serviceOverview.rechargeControl.p5': 'Stop recharging',
  'pages.serviceOverview.workStateQuery': 'Query Working Status',
  'pages.serviceOverview.workStateQuery.p1': 'Query the robot\'s current working status.',
  'pages.serviceOverview.workStateQuery.p2': 'Robot nickname, used to find the device',
  'pages.parameterName': 'Parameter',
  'pages.parameterType': 'Type',
  'pages.parameterDescription': 'Description',
  'pages.serviceOverview.workStateQuery.d1': 'Cleaning status, exists when request is successful. s-cleaning, p-paused, h-idle, goposition-going to specified position, gopositionpause-stopped at specified point, findpet-finding pet, findpetpause-pet finding paused, cruise-cruising, cruisepause-cruise paused, buildmap-creating map, buildmappause-map building paused',
  'pages.serviceOverview.workStateQuery.d2': 'Charging status, exists when request is successful. g-returning to charge, gp-return to charge paused, i-idle, sc-dock charging, wc-wire charging, charging-charging (includes SC and WC)',
  'pages.serviceOverview.workStateQuery.d3': 'Station status, i-idle, wash-washing mop, dry-drying, drypause-drying paused, dust-dust collecting, dustpause-dust collection paused, clean-station cleaning, cleanpause-station cleaning paused, wash-washing mop, washpause-mop washing paused',
  'pages.preparationForUse': 'Preparation for Use',
  'pages.preparationForUse.p1': '1. Login Ecovacs Account',
  'pages.preparationForUse.p2': 'Login instructions: Enter your phone number and verification code to login your Ecovacs account.',
  'pages.preparationForUse.p3': '2. Get Service Key (AK)',
  'pages.preparationForUse.p4': 'Get instructions: After logging in to your Ecovacs account, select the appropriate validity period, copy and store your service key AK.',
  'pages.preparationForUse.p5': 'Go to Login',
  'pages.preparationForUse.p6': 'Go to Get',
  'pages.updateLog': 'Update Log',
  'pages.updateLog.p1': 'Version',
  'pages.updateLog.p2': 'Function Description',
  'pages.updateLog.p3': 'Update Date',
  'pages.updateLog.p4': 'Ecovacs MCP Server officially launched',
  'pages.contactUs': 'Contact Us',
  'pages.contactUs.email': 'Contact Email',
  'pages.contactUs.qrCode': 'Wechat Group QR Code',

  'pages.hub.title': 'Ecovacs Hub',
  'pages.hub.mcpServer': 'MCP Server',
  'pages.hub.skillHub': 'Skills',
  'pages.hub.opensource': 'Open Source',
  'pages.opensource.addProject': '+ Add project',

  'pages.skill.category.deebot': 'Deebot',
  'pages.skill.category.goat': 'GOAT',
  'pages.skill.category.hsr': 'HSR',
  'pages.skill.category.winbot': 'WINBOT',
  'pages.skill.category.mower': 'Mower',
  'pages.skill.category.other': 'Other',
  'pages.skill.build.name': 'Skill name',
  'pages.skill.build.nameRequired': 'Please enter skill name',
  'pages.skill.build.version': 'Version',
  'pages.skill.build.versionRequired': 'Please enter version',
  'pages.skill.build.versionFormat': 'Version format: x.x.x (e.g. 1.0.0)',
  'pages.skill.build.description': 'Description',
  'pages.skill.build.descriptionRequired': 'Please enter description',
  'pages.skill.build.type': 'Skill type',
  'pages.skill.build.typeRequired': 'Please select skill type',
  'pages.skill.build.enabled': 'Enabled',
  'pages.skill.build.public': 'Public',
  'pages.skill.build.zip': 'Zip archive',
  'pages.skill.build.zipHint': 'Click to upload or drag files here',
  'pages.skill.build.zipExtra': 'Supports .tar.gz, .zip, and .skill formats',
  'pages.skill.build.zipRequired': 'Please upload a zip file',
  'pages.skill.build.submit': 'Submit',
  'pages.skill.build.success': 'Skill created successfully',
  'pages.skill.build.submitFailed': 'Submit failed',
  'pages.skill.build.submitting': 'Submitting…',
  'pages.skill.build.pageTitle': 'Upload Skill',
  'pages.skill.build.versionPlaceholder': '1.0.0',
  'pages.skill.build.parsing': 'Parsing skill metadata...',
  'pages.skill.build.autofillSuccess': 'Auto-filled form from uploaded skill file',
  'pages.skill.build.autofillFailed': 'File selected, but skill name/description could not be parsed',
  'pages.skill.build.preview': 'Preview',
  'pages.skill.build.previewEmpty': 'After uploading .skill or .zip, SKILL.md content will be shown here',
  'pages.skill.build.notAllowed': 'Not allowed to upload skills',

  'pages.skill.plaza.uploadSkill': 'Upload skill',
  'pages.skill.plaza.filterAll': 'All',
  'pages.skill.plaza.clawhubLink': 'OpenClaw ClawHub (open skill registry)',
  'pages.skill.plaza.loadError': 'Failed to load skills',
  'pages.skill.plaza.retry': 'Retry',
  'pages.skill.plaza.noDesc': 'No description',
  'pages.skill.plaza.version': 'Ver.',
  'pages.skill.plaza.updated': 'Updated',
  'pages.skill.plaza.download': 'Download',
  'pages.skill.plaza.delete': 'Delete',
  'pages.skill.plaza.noFile': 'No attachment',
  'pages.skill.plaza.downloadOk': 'Download started',
  'pages.skill.plaza.downloadFail': 'Download failed',
  'pages.skill.plaza.deleteConfirmTitle': 'Delete skill',
  'pages.skill.plaza.deleteConfirmDesc': 'Delete “{name}”? This cannot be undone.',
  'pages.skill.plaza.deleteOk': 'Deleted',
  'pages.skill.plaza.deleteFail': 'Delete failed',
  'pages.skill.plaza.deleteNotAllowed': 'Not allowed to delete skills',
  'pages.skill.plaza.empty': 'No skills in this category',
  'pages.skill.plaza.category': 'Category',
  'pages.skill.plaza.tagEnabled': 'Enabled',
  'pages.skill.plaza.tagDisabled': 'Disabled',
  'pages.skill.plaza.tagPublic': 'Public',
  'pages.skill.plaza.tagPrivate': 'Private',
  'pages.skill.plaza.totalItems': 'skills',
  'pages.skill.plaza.noMore': 'No more skills',
  'pages.skill.detail.title': 'Skill Details',
  'pages.skill.detail.back': 'Back to Skill Plaza',
  'pages.skill.detail.loadError': 'Failed to load skill details',
  'pages.skill.detail.notFound': 'Skill not found',
  'pages.skill.detail.name': 'Skill Name',
  'pages.skill.detail.description': 'Description',
  'pages.skill.detail.fileTree': 'File Tree',
  'pages.skill.detail.fileReadError': 'Failed to read skill files',
  'pages.skill.detail.skillMdMissing': 'SKILL.md not found',
  'pages.skill.detail.downloadSkill': 'Download skill',
  'pages.skill.detail.versionHistory': 'Version History',
  'pages.skill.detail.currentVersion': 'Current',
  'pages.skill.detail.currentVersionLabel': 'Current Version',
  'pages.skill.detail.downloadVersion': 'Download',
  'pages.skill.detail.noFile': 'No file',
  'pages.skill.detail.noVersions': 'No version history yet',
  'pages.skill.plaza.mock1.name': 'Kids room toy tidy',
  'pages.skill.plaza.mock1.desc': 'Detect scattered toys and sort into bins for daily cleanup.',
  'pages.skill.plaza.mock2.name': 'Desk declutter',
  'pages.skill.plaza.mock2.desc': 'Organize pens, books, and clutter to keep a usable workspace.',
  'pages.skill.plaza.mock3.name': 'Entryway shoes',
  'pages.skill.plaza.mock3.desc': 'Align shoes and remind about sock pairing.',
  'pages.skill.plaza.mock4.name': 'Laundry sorting hints',
  'pages.skill.plaza.mock4.desc': 'Separate colors and fabrics with wash program suggestions.',
  'pages.skill.plaza.mock5.name': 'Custom scenario',
  'pages.skill.plaza.mock5.desc': 'Extensible template for other home collaboration skills.',
};
